module.exports = __webpack_public_path__ + "img/logo.2d8ffeff.svg";